const searchForm = {
  state: {
    data: {},
    date: []
  },

  mutations: {
    SET_SEARCH: (state, data) => {
      state.data = data
    },
    SET_SEARCHDAY: (state, data) => {
      state.date = data
    }
  },

}

export default searchForm
